import React from "react";
import PropTypes from "prop-types";
import CardLongTwoColumn from "./CardLongTwoColumn";
import CardLongTextContainer from "./CardLongTextContainer";

const CardLongContent = ({
  children = null,
  className = "",
  layoutVariation,
  scrollToTop = () => {},
  ...rest
}) => {
  layoutVariation = layoutVariation || "default";
  className = className || "card__content--" + layoutVariation;
  return (
    <div className={`card__content ${className}`}>
      {React.Children.map(children, (child) => {
        if (
          (child && child.type && child.type === CardLongTextContainer) ||
          (child && child.type && child.type === CardLongTwoColumn)
        ) {
          return React.cloneElement(child, { scrollToTop });
        }
        return child;
      })}
    </div>
  );
};

CardLongContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default CardLongContent;
